export const validateString = (e: React.KeyboardEvent<any>) => {
    const characterCode = e.key
    const regex = /^(?:"&*^[0-9a-zA-Z]+)$/i;
    const isValid = regex.test(characterCode);
    if (!isValid) {
        e.preventDefault();
    }
}

export const validateLetter = (e: React.KeyboardEvent<any>) => {
    const characterCode = e.key
    const regex = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+$/i;
    const isValid = regex.test(characterCode);
    if (!isValid) {
        e.preventDefault();
    }
}

export const validateNumber = (e: React.KeyboardEvent<any>) => {
    if (e.keyCode === 8 || e.keyCode === 46 ||
        e.keyCode === 37 || e.keyCode === 39 ||
        e.keyCode === 9) {
        return;
    }
    const characterCode = e.key
    const regex = /[0-9]|\./;
    const isValid = regex.test(characterCode);
    if (!isValid) {
        e.preventDefault();
    }
}
export const validateSpaces = (e: React.KeyboardEvent<any>) => {
    const characterCode = e.key
    if (characterCode.indexOf(" ") !== -1 || characterCode.indexOf(".") !== -1
        ) {
        e.preventDefault();
    }
}
export const validateNit = (e: React.KeyboardEvent<any>) => {
    const characterCode = e.key
    let digits: any = [];
    for (let i = 0; i < characterCode.length; i++) {
        digits[i] = characterCode[i];
    }
}
export const validateSpecialString = async (e: React.KeyboardEvent<any>) => {
    const characterCode = e.key;
    const specials = /[*$%&@+~|<>#]/;
    if (characterCode.match(specials)) {
        e.preventDefault();
    }
}